import { useEffect } from 'react';

export const useAnimationFrame = (callback: (elapsed: number) => void) => {
  useEffect(() => {
    let id: number;
    let lastTime = 0;
    const onAnimationFrame = (time: number) => {
      callback(!lastTime ? 0 : time - lastTime);
      lastTime = time;
      id = requestAnimationFrame(onAnimationFrame);
    };
    id = requestAnimationFrame(onAnimationFrame);
    return () => cancelAnimationFrame(id);
  }, [callback]);
};
